/* eslint-disable react/destructuring-assignment */
import { useAccount } from "hooks/useAccounts";
import { isEmpty } from "lodash";
import moment from "moment";
import Message from "pages/forms/_components/_fields/_scheduler/Message";
import { transactionStatus } from "pages/transactions/constants";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import Loader from "pages/_components/Loader";
import { TransactionSign } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { bool, func, shape, string } from "prop-types";
import React, { useContext, useState } from "react";
import * as i18n from "util/i18n";
import * as schedulerUtils from "util/scheduler";

const InternalTransferSummaryBody = (props) => {
    const { ticket, showMoreData, setShowMoreData, isDesktop } = props;
    const { transaction = {} } = useContext(TransactionContext);
    const {
        data = {},
        creationDateTime = moment(),
        idTransaction = "",
        idTransactionStatus = "",
        programed = false,
    } = transaction;
    const isFinished = idTransactionStatus === transactionStatus.FINISHED;
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const {
        debitAccount = props.debitAccountId,
        debitAccountLabel = props.debitAccountLabel,
        creditAccount = props.creditAccountId,
        creditAccountLabel = props.creditAccountLabel,
        amount = props.amount,
        reference = props.reference,
        reason = props.reason,
        sendEmail = props.sendEmail,
        email = props.email,
        emailText = props.emailText,
        nameRecipient = "",
        cuitRecipient = "",
        transactionNumber = "",
        scheduler = props.scheduler,
    } = data;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeLess.button");

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const isProgramed = programed || !isEmpty(scheduler);

    const showEmailInfo = sendEmail;
    const lapseEndText = (lapse, times = 0, date) => {
        switch (lapse) {
            case "UNLIMITED":
                return i18n.get("scheduler.never");
            case "UNTIL":
                return moment(date).format("ll");
            case "UP_TO":
                return `${i18n.get("scheduler.after")} ${times} ${i18n.get("scheduler.times").toLowerCase()}`;
            default:
                return "";
        }
    };

    const {
        fetching: fetchingDebitAccount,
        account: _debitAccount,
        formatAccountBody: formatDebitAccountBody,
    } = useAccount("productId", debitAccount);

    const {
        fetching: fetchingCreditAccount,
        account: _creditAccount,
        formatAccountBody: formatCreditAccountBody,
    } = useAccount("productId", creditAccount);

    if (fetchingDebitAccount || fetchingCreditAccount) {
        return <Loader />;
    }

    const ProgrammedBody = () => {
        if (!isProgramed) {
            return null;
        }

        if (scheduler.program?.isCustom) {
            return (
                <>
                    <CustomData
                        titleText="scheduler.custom"
                        titleTextType="I18N"
                        valueText={<Message value={scheduler || { valueDate: "" }} />}
                    />
                    {ticket ? (
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                    ) : (
                        <div className="horizontal-divider col-span-full" />
                    )}
                </>
            );
        }

        if (scheduler.selectedOption === schedulerUtils.ONCE) {
            return (
                <>
                    {ticket && (
                        <>
                            <div className="ticket__divider inside-ticket__body">
                                <div className="ticket__notch ticket__notch--left"> </div>
                                <div className="ticket__notch ticket__notch--right"> </div>
                            </div>
                            <h2>{i18n.get("", "Datos de programación")}</h2>
                        </>
                    )}
                    <CustomData
                        titleText="scheduler.label"
                        titleTextType="I18N"
                        valueText={
                            isFinished || isPending ? (
                                <CustomText
                                    textType="DATE"
                                    className="data-label"
                                    text={scheduler?.program?.startsOn || creationDateTime}
                                />
                            ) : (
                                <b>
                                    <Message value={scheduler || { valueDate: "" }} />
                                </b>
                            )
                        }
                    />
                    <CustomData
                        titleText="scheduler.frequency"
                        titleTextType="I18N"
                        valueText="scheduler.future"
                        valueTextType="I18N"
                    />
                </>
            );
        }

        return (
            <>
                <CustomData
                    titleText="scheduler.label"
                    titleTextType="I18N"
                    valueText={scheduler?.program?.startsOn || creationDateTime}
                    valueTextType="DATE"
                />
                <CustomData
                    titleText="scheduler.frequency"
                    titleTextType="I18N"
                    valueText={`scheduler.${scheduler?.program?.frequency?.toLowerCase()}`}
                    valueTextType="I18N"
                />
                <CustomData
                    titleText="scheduler.end"
                    titleTextType="I18N"
                    valueText={lapseEndText(
                        scheduler?.program?.lapse,
                        scheduler?.program?.number,
                        scheduler?.program?.date,
                    )}
                />
                {ticket ? (
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                ) : (
                    <div className="horizontal-divider col-span-full" />
                )}
            </>
        );
    };

    if (ticket) {
        return (
            <>
                <div className="ticket__body">
                    <div className="ticket-section section_trasfers">
                        <div className="ticket-header-info">
                            <CustomData
                                titleText="transfer.creditAccount.label"
                                titleTextType="I18N"
                                valueText={creditAccountLabel}
                            />
                        </div>
                        <div className="ticket-header-info">
                            {isProgramed ? (
                                <CustomData
                                    dataClass="amount tag tag-info"
                                    titleClass="text-right"
                                    titleText="echecks.emit.amountField.label"
                                    titleTextType="I18N"
                                    valueText={
                                        <FormattedAmount currency={amount.currency} quantity={amount.quantity} />
                                    }
                                />
                            ) : (
                                <CustomData
                                    dataClass={`amount tag tag-${isPending ? "warning" : "echeq-character"}`}
                                    titleClass="text-right"
                                    titleText="echecks.emit.amountField.label"
                                    titleTextType="I18N"
                                    valueText={
                                        <FormattedAmount currency={amount.currency} quantity={amount.quantity} />
                                    }
                                />
                            )}
                        </div>
                    </div>
                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                        <h2>{i18n.get("", "Datos adicionales")}</h2>
                        <CustomData
                            titleText="transfer.debitAccount.label"
                            titleTextType="I18N"
                            valueText={debitAccountLabel}
                        />
                        <CustomData
                            titleText="transfer.frequentDestination.document"
                            titleTextType="I18N"
                            valueText={`CUIT ${cuitRecipient}`}
                        />
                        <CustomData
                            titleText="ticket.voucher"
                            titleTextType="I18N"
                            valueText={transactionNumber || idTransaction.substring(0, 8).toUpperCase()}
                        />
                        <CustomData titleText="transfer.sender.label" titleTextType="I18N" valueText={nameRecipient} />
                        <CustomData titleText="transfer.bank.label" titleTextType="I18N" valueText="BiBank" />
                        <CustomData titleText="transfer.reference.label" titleTextType="I18N" valueText={reference} />
                        <CustomData titleText="transfer.reason.label" titleTextType="I18N" valueText={reason} />
                        {showEmailInfo && (
                            <>
                                <div className="ticket__divider divider_1 inside-ticket__body">
                                    <div className="ticket__notch ticket__notch--left"> </div>
                                    <div className="ticket__notch ticket__notch--right"> </div>
                                </div>
                                <CustomData titleText="transfer.email.label" titleTextType="I18N" valueText={email} />
                                <CustomData
                                    titleText="transfer.emailText.label"
                                    titleTextType="I18N"
                                    valueText={emailText}
                                />
                            </>
                        )}
                        {isProgramed && <ProgrammedBody />}
                        <TransactionSign
                            creationTime
                            hasVaucher
                            isDesktop={isDesktop}
                            noDate={isPending}
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
            </>
        );
    }

    return (
        <GridTable className="form-summary">
            <GridTable.Container>
                <ProgrammedBody />
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.debitAccount.label"
                        titleTextType="I18N"
                        valueText={formatDebitAccountBody(_debitAccount)}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.creditAccount.label"
                        titleTextType="I18N"
                        valueText={formatCreditAccountBody(_creditAccount)}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="transfers.send.mail.amount"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={amount.currency} quantity={amount.quantity} />}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.reference.label"
                        titleTextType="I18N"
                        valueText={reference}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.reason.label"
                        titleTextType="I18N"
                        valueText={reason}
                    />
                </GridTable.Data>
                {showEmailInfo && (
                    <>
                        <div className="horizontal-divider col-span-full" />

                        <GridTable.Data>
                            <CustomData titleText="transfer.email.label" titleTextType="I18N" valueText={email} />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="transfer.emailText.label"
                                titleTextType="I18N"
                                valueText={emailText}
                            />
                        </GridTable.Data>
                    </>
                )}
            </GridTable.Container>
        </GridTable>
    );
};

InternalTransferSummaryBody.propTypes = {
    debitAccountId: string,
    creditAccountId: string,
    amount: shape({
        quantity: string,
        currency: string,
    }),
    sendEmail: bool,
    email: string,
    emailText: string,
    scheduler: shape({}),
    ticket: bool,
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

InternalTransferSummaryBody.defaultProps = {
    debitAccountId: "",
    creditAccountId: "",
    amount: {
        quantity: "",
        currency: "",
    },
    sendEmail: false,
    email: "",
    emailText: "",
    scheduler: null,
    ticket: false,
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => { },
};

export default InternalTransferSummaryBody;
